import { convertStatesAndAbbreviations } from "../../components/Factory";
import { lessorsRiskClasses } from "./constants";

const businessTypesNotWithLessorRisk = [
  "convenience store",
  "distributor",
  "restaurant-casual dining",
  "restaurant-fine dining",
  "restaurant-fast food"
];

export const classCodeFilter = ({
  data,
  busType,
  searchText = "",
  lessorsRiskIndicator,
  selectedClasses = [],
  primaryRateState = ""
}) => {
  if (!data) return [];

  return data.filter(c => {
    //primary Rate State filtering
    const addressStates = c?.jurisdiction || [];
    const addressStatesCodes = addressStates.map(stateName =>
      convertStatesAndAbbreviations(stateName, "abbr")
    );
    const hasJurisdiction = addressStatesCodes.includes(primaryRateState);
    const ps = (c?.jurisdiction || []).length === 0 ? true : !!hasJurisdiction;

    // business type filtering
    const b = !!busType
      ? Array.isArray(busType)
        ? busType.length
          ? busType.includes(c.businessType_UFG.toLowerCase())
          : true
        : c.businessType_UFG.toLowerCase() === busType.toLowerCase()
      : true;
    // search text filtering
    const s = !!searchText
      ? c.description.toLowerCase().includes(searchText.toLowerCase()) ||
        c.code.toLowerCase().includes(searchText.toLowerCase())
      : true;

    // selected classes filtering
    const sel = !(selectedClasses || []).some(s => c.code === s.code);

    // is this class a lessors' risk class?
    const lessorsRiskFound = lessorsRiskClasses.find(
      cl => c.description === cl.description && c.code === cl.code
    );

    /**
     * business type not with lessor risk
     * https://ufginsurance.atlassian.net/browse/OOQ-13961
     * if is lessor risk, then don't show classes from specific business types
     */
    const btnwlr = lessorsRiskIndicator
      ? !businessTypesNotWithLessorRisk.includes(
          c.businessType_UFG.toLowerCase()
        )
      : true;

    // hide all the items marked hidden:
    // if lessorsFlag "Yes", then display whichever matches .isLessorsRisk "true"
    // if lessorsFlag "No", then display whichever no found or isLessorsRisk "false"
    // if not, then display the class (true)
    const l =
      lessorsRiskFound?.isLessorsRisk === "hidden"
        ? false
        : !!lessorsRiskIndicator
        ? lessorsRiskFound?.isLessorsRisk === "true"
        : !lessorsRiskIndicator
        ? !lessorsRiskFound || lessorsRiskFound?.isLessorsRisk === "false"
        : true;

    return ps && b && s && l && sel && btnwlr;
  });
};
